import { SearchDropdownItem } from "components/UI/molecules";
import "./index.scss";

export const SearchBrandsDropdown = ({ brands = [], canShowDropdown }) => {
  return canShowDropdown && brands.length ? (
    <div
      className="search-brands-dropdown dropdown-position"
      data-testid="search-brands-dropdown"
    >
      {brands.map((item) => (
        <SearchDropdownItem key={item.id} {...item} />
      ))}
    </div>
  ) : (
    <div className="search-empty" />
  );
};
